import { Directive, HostListener } from '@angular/core';
import { Throttle } from 'src/shared-app-portal/directives/throttle/throttle';

@Directive({
  selector: '[appThrottleClick]',
  standalone: false
})
export class ThrottleClickDirective extends Throttle {
  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
